'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'peach';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e20b';
var svgPathData = 'M288 280c0-66.3-53.7-120-120-120S48 213.7 48 280c0 48.1 42.1 93.7 105 132 29.2 17.8 58.8 31.5 81.3 40.7 8.5 3.5 15.9 6.3 21.7 8.5 5.8-2.1 13.2-5 21.7-8.5 22.5-9.3 52.1-22.9 81.3-40.7 62.9-38.3 105-83.9 105-132 0-66.3-53.7-120-120-120-17.4 0-33.9 3.7-48.8 10.3 25.4 29.4 40.8 67.8 40.8 109.7l-48 0zM151.6 112.8C118.3 93.4 96 57.3 96 16l0-16 48 0C205.9 0 256 50.1 256 112 256 50.1 306.1 0 368 0l48 0 0 16c0 41.3-22.3 77.4-55.6 96.8 85.1 8.2 151.6 80 151.6 167.2 0 152-256 232-256 232S0 432 0 280c0-87.3 66.5-159 151.6-167.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;